module.exports = __webpack_public_path__ + "@/assets/img/angle-up.2e944154.svg";